import { render, staticRenderFns } from "./SubscribePlan.vue?vue&type=template&id=24084396"
import script from "./SubscribePlan.vue?vue&type=script&lang=js"
export * from "./SubscribePlan.vue?vue&type=script&lang=js"
import style0 from "./SubscribePlan.vue?vue&type=style&index=0&id=24084396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports